import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainOfferDateSelectorType } from "../../../Orchestrator/Types/Index";

export class DateSelectorPrevNextAction extends BaseAction<void, TrainOfferDateSelectorType> {

    override async run(): Promise<void | null> {
        try {
            const { action, startIndex, endIndex, dates, selectedDate } = this.params!;
            if (action == "prev") {
                if (startIndex > 0) {
                    updateRecoilState("startIndexDateSelectorAtom", (startIndex - 1));
                }
            }
            if (action == "next") {
                if (endIndex < dates?.length) {
                    updateRecoilState("startIndexDateSelectorAtom", (startIndex + 1));
                }
            }
        } catch (error) {
            console.error("Error in DateSelectorPrevNextAction:", error);
        }
    }
}

// Create a singleton instance
export const dateSelectorPrevNextAction = new DateSelectorPrevNextAction(); 